<template>
	<CFormLightbox
		v-if="open"
		:entry-key="entryKey"
		:admin-api="adminApi"
		:form-id="formId"
		:view-token="viewToken"
		:view-id="viewId"
		:task-role-id="roleId"
		:dialog-title="title"
		:inline-action-name="inlineActionName"
		:show-localized-error="showLocalizedError"
		:client-role="clientRole"
		:user-email="userEmail"
		:entry-json="entryJson"
		:embed-context="embedContext"
		@before-submit="handleBeforeSubmit"
		@submit="handleSubmit"
		@close-dialog="handleClose"
	/>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import { useFormLightboxState } from './utils/use-form-lightbox';
	import { globalStore } from 'src/stores/global-store';
	import CFormLightbox from './FormLightbox.vue';

	export default defineComponent({
		name: 'CFormLightboxContainer',
		components: { CFormLightbox },
		setup() {
			const lightboxState = useFormLightboxState();

			const handleBeforeSubmit = () => {
				if (lightboxState.beforeSubmitCallback)
					lightboxState.beforeSubmitCallback();
			};

			const handleSubmit = (confirmationMessage: string) => {
				if (lightboxState.submitCallback)
					lightboxState.submitCallback(confirmationMessage);
			};

			const handleClose = async () => {
				lightboxState.open = false;

				if (lightboxState.closeCallback)
					lightboxState.closeCallback();

				if (lightboxState.destroyAdminApi)
					await lightboxState.adminApi.destroy(lightboxState.formId);
			};

			const clientRole = globalStore.organization.Role;
			const userEmail = (lightboxState.sendGuestSaveResumeLink) ? globalStore.user.Email : null;

			return {
				...lightboxState,
				handleBeforeSubmit,
				handleSubmit,
				handleClose,
				clientRole,
				userEmail
			};
		}
	});
</script>